import React from 'react';
import PropTypes from 'prop-types';
import Voln from '../components/svg/Voln';
import Cub from '../components/svg/Cub';
import ServiceList from '../components/03_organisms/ServiceList';
import Works from '../components/03_organisms/Works';
import Busin from '../components/03_organisms/Business';
import SeoText from '../components/03_organisms/SeoText';
import SubRequest from '../utils/subrequestApi';
import Metatags from '../components/01_atoms/Metatags';
import ClientLogos from '../components/02_moleculas/ClientLogos';

class HomePage extends React.Component {
  static async getInitialProps({ req }) {
    let initialProps = {
      statusCode: 200,
    };

    try {
      const request = new SubRequest(req);
      // 'Front' config page.
      request.addSubRequest({
        url: '/api/front',
        requestId: 'main',
      });
      // Service types.
      request.addSubRequest({
        url: '/api/service-types',
        requestId: 'serviceTypes',
      });
      // Portfolio.
      request.addSubRequest({
        url: '/api/projects/main',
        requestId: 'projects',
      });
      const response = await request.send();
      initialProps = {
        main: response.main,
        serviceTypes: response.serviceTypes.serviceTypes,
        projects: response.projects,
      };
    } catch (e) {
      // Pass status code as internal properly. It is being checked inside of
      // render() method of _app.js.
      initialProps.statusCode = 500;
    }
    return initialProps;
  }

  render() {
    const { main, serviceTypes, projects } = this.props;
    return (
      <div className="main-wrapper">
        <Metatags metatags={main.meta} />
        <SeoText paragraph={main.bottomText} title={main.title} />
        <div id="content">
          <div className="wrapper">
            <Cub width="15" height="15" color="#d8cdd8" />
            <Voln className="one" />
            <Voln className="two" />
            <img src="../static/images/voln-in.png" className="tir" alt="img" />
            <div className="content">
              <div
                className="content__title"
                data-aos="fade-left"
                data-aos-delay="30"
                data-aos-duration="500"
              >
                <div className="gpbol heading">{main.slogan}</div>
              </div>
              <div
                className="content__title2"
                data-aos="fade-right"
                data-aos-delay="30"
                data-aos-duration="1000"
              >
                <div className="infog">
                  {main.numbers.slice(0, 3).map(number => (
                    <div className="infog__list" key={Math.random()}>
                      <div className="num gpbol">{number.number}</div>
                      <div className="gpreg" dangerouslySetInnerHTML={{ __html: number.description }} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="arrow_in" />
          </div>
        </div>
        <ServiceList serviceTypes={serviceTypes} showTitle />
        <Works
          portfolioLink
          projects={projects}
          withTitle
        />
        <Busin banner={main.banner} />
        <ClientLogos />
      </div>
    );
  }
}

HomePage.propTypes = {
  main: PropTypes.shape({
    slogan: PropTypes.string,
    banner: PropTypes.shape({}),
    bottomText: PropTypes.shape({}),
    meta: PropTypes.arrayOf(PropTypes.shape({})),
    title: PropTypes.string,
    numbers: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  serviceTypes: PropTypes.shape({}).isRequired,
  projects: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

HomePage.defaultProps = {
  main: {
    slogan: 'МАРКЕТИНГОВЫЕ РЕШЕНИЯ ДЛЯ БИЗНЕСА',
    bannerForMain: null,
    bottomText: null,
    numbers: [],
  },
};

export default HomePage;
